import {User} from "../users/User";
import {isAdmin, isApplicationAdmin} from "../users/AccountServiceRoles";
import {Application} from "./Application";

export function mayViewApplication(user: User, application: Application) {
  return true;
}

export function mayEditApplication(user: User, application: Application) {
  if (isAdmin(user)) {
    return true;
  }
  if (isApplicationAdmin(user)) {
    return !!user.applicationRoles.find((appRole) => appRole.application.name === application.name && appRole.role === application.adminRole);
  }
  return false
}
